export default __webpack_public_path__ + "static/media/error-icon.32545fc2.svg";